export default {
  id: 'gruas-monterrey',
  displayName: 'Gruas Monterrey',
  legalName: 'GRUAS MONTERREY SA DE CV',
  addressLine1: 'CERRO LARGO 5503',
  addressLine2: 'MONTERREY, NUEVO LEON CP: 64170',
  rfc: 'GMO740715IF8',
  topbarColor: '#ffc434',
  topbarLogo: require('@/assets/logogruas.png'),
}
